import { LOCALE_DEFINITIONS, type LocaleDefinition } from '@/i18n/localeConfig'

export type LanguageType = LocaleDefinition & {
  /** @deprecated use nativeName */
  language: string
}

export const languages: LanguageType[] = LOCALE_DEFINITIONS.map((item) => ({
  ...item,
  language: item.nativeName,
}))
